import {
  Theme,
  useTheme,
  Icon,
  ListItemIcon,
  TIcons,
} from '@yuno/design-system-web'

import {
  AccountMenuItemStyled,
  StyledMenuItemLabel,
} from './account-menu.styled'

export type AccountMenuItemProps = {
  iconName?: TIcons
  label: string | React.ReactElement
  onClick?: () => void
}

export const AccountMenuItem = ({
  iconName,
  label,
  onClick,
}: AccountMenuItemProps) => {
  const theme: Theme = useTheme()

  return (
    <AccountMenuItemStyled onClick={onClick}>
      {iconName && (
        <ListItemIcon>
          <Icon
            name={iconName}
            weight="light"
            size="16px"
            color={theme.palette.grey[5]}
          />
        </ListItemIcon>
      )}
      <StyledMenuItemLabel>{label}</StyledMenuItemLabel>
    </AccountMenuItemStyled>
  )
}
